// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormSelect, FormRadio } from '../../../../components/index';
import { league_tooltips } from '../../../../helpers/index';

type Props = {
	is_traders: boolean,
};

export const TradersSettings = ({ is_traders }: Props) => (
	<div>
		<FormRadio
			label='Restricted Free Agents'
			name='trade_waivers'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.trade_waivers}
			is_disabled={false}
		/>

		<Field
			label='Restricted Free Agent Time Period'
			name='waiver_period'
			component={FormSelect}
			options={[
				{
					value: 1,
					text: '1 day',
				},
				{
					value: 2,
					text: '2 days',
				}
			]}
			tooltip={league_tooltips.waiver_period}
			is_disabled={!is_traders}
		/>

		<Field
			label='Restricted Free Agent Order Policy'
			name='waiver_order'
			component={FormSelect}
			options={[
				{
					value: 0,
					text: 'Reverse Ladder Order',
				},
				{
					value: 1,
					text: 'Last Pick to Bottom ',
				}
			]}
			tooltip={league_tooltips.waiver_order}
			is_disabled={!is_traders}
		/>

		<FormRadio
			label='Restricted Free Agent Privacy'
			name='rfa_privacy'
			elements={[
				{
					value: 'public',
					text: 'Public',
				},
				{
					value: 'private',
					text: 'Private',
				}
			]}
			tooltip={league_tooltips.rfa_privacy}
			is_disabled={!is_traders}
			is_string_value={true}
		/>

		<Field
			label='Trade Approval Options'
			name='approve_trade'
			component={FormSelect}
			options={[
				{
					value: 'league',
					text: 'League Approved',
				},
				{
					value: 'commissioner',
					text: 'Commissioner Approved',
				},
				{
					value: 'free',
					text: 'Free for all ',
				}
			]}
			tooltip={league_tooltips.approve_trade}
		/>

	</div>
);

export default TradersSettings;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesCreate/forms/TradersSettings.js